import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { BudgetPeriod, type BudgetPeriodConstructor } from './BudgetPeriod'

export const BudgetPeriodConstructorFactory =
  Factory.Sync.makeFactory<BudgetPeriodConstructor>({
    startDate: Factory.each(() => faker.date.past().toISOString()),
    endDate: Factory.each(() => faker.date.future().toISOString()),
    expired: false,
  })

export const BudgetPeriodFactory = EntityFactory(
  BudgetPeriod,
  BudgetPeriodConstructorFactory
)
